<template>
  <div>
    <div class="header_index_nav">
      <header>
        <div class="index_nav_white top">
          <div class="nav_box">
            <div class="nav_flex">
              <div class="nav_logo_b"></div>
              <div class="nav_li">
                <div class="nav_li_text" @click="headerClick('aboutus')">关于我们</div>
                <div class="nav_li_text" @click="headerClick('society')">社会责任</div>
                <div class="nav_li_text" @click="headerClick('news')">新闻动态</div>
                <div class="nav_li_text" @click="headerClick('InvestorRelations')">投资者关系</div>
                <div class="nav_li_text" @click="headerClick('joinUs')">加入我们</div>
              </div>
              <i class="iconfont icon-website-shouye index_m"></i>
            </div>
          </div>
        </div>
      </header>
    </div>
    <main class="index_main_content">
      <div class="news_content_box">
        <div class="JD_box">
          <div class="zhiwei_title">{{detailData?detailData.title:''}}</div>
          <div class="JD_tag">
            <div>{{detailData?detailData.city:''}}</div>
            <div>{{detailData?getPositionName(detailData.positionTypeDesign,detailData.positionTypeDevelop,detailData.positionTypeGame,detailData.positionTypeProduct):""}}</div>
            <div>{{detailData?detailData.jobType:''}}</div>
            <div>{{detailData?detailData.source:''}}</div>
            <div>更新于{{detailData.updatime}}</div>
          </div>
          <div class="JD_content">
            <div class="list_title">岗位职责</div>
            <div class="list_word">
              {{detailData?detailData.ask:''}}
            </div>
          </div>
          <div class="JD_content">
            <div class="list_title">岗位要求</div>
            <div class="list_word">
              {{detailData?detailData.responsibility:''}}
            </div>
          </div>
          <div class="JD_email">
            <div class="email_title">投递邮箱</div>
            <div class="email_name"><a :href="'mailto:' + (detailData?detailData.email:'')">{{detailData?detailData.email:''}}</a></div>
          </div>
        </div>
      </div>

    </main>
    <footer-build @gotoBody="gotoBody"></footer-build>
    
    
  </div>
</template>
<script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import UtilEvent from '../utils/UtilEvent'
  export default {
    name: 'RecruitDetail',
    props: ['detailId'],
    data(){
      return{
        positionType:[
          {
            key:'positionTypeDesign',
            name:'设计',
          },
          {
            key:'positionTypeDevelop',
            name:'开发',
          },
          {
            key:'positionTypeGame',
            name:'游戏',
          },
          {
            key:'positionTypeProduct',
            name:'产品',
          }
          
        ],
        
        recruitData:{
          total:0,
          list:[]
        },
        detailData:null
      }
    },
    methods:{
      ...mapActions("global", ["ActionSetCurrentTap"]),
      gotoBody(){
        this.$refs.parentDiv.scrollIntoView({
            behavior: "smooth",  // 平滑过渡
        });
      },
      getPositionName(...params){
        let result = "";
        for(let i = 0;i < params.length;i++){
          if(params[i]){
            result = result + this.positionType[i].name + "  " ;
          }
        }
        return result;
      } ,
      longToDate(longData){
        debugger
        let dateTypeDate = "";
        let date = new Date();
        date.setTime(longData);
        dateTypeDate += date.getFullYear();
        dateTypeDate += "-" + date.getMonth(date) ;
        dateTypeDate += "-" + date.getDay(date);
        dateTypeDate += " " + date.getHours(date);
        dateTypeDate += ":" + date.getMinutes(date);
        dateTypeDate += ":" + date.getSeconds(date);
        return dateTypeDate;
      },
      toMain(){
        // this.ActionSetCurrentTap('');
        this.$router.push({name:'main'})
      },
      headerClick(pageName){
        this.ActionSetCurrentTap(pageName);
        this.$router.push(pageName);
      },
     
      getRecruitDetail(detailId){
        new UtilEvent().getRecruitDetail(this,detailId);
      }
     
    },
    mounted(){
      this.getRecruitDetail(this.$route.query.detailId);
    }
  }
  </script>

